class SessionClient {
    constructor(baseUrl, timeout) {
        this.__baseUrl = baseUrl;
        this.__timeout = timeout;
    }

    getToken() {
        //return fetch(this.__baseUrl + "/session/token.secured", {
        return fetch(this.__baseUrl + "/session/token", {
            signal: AbortSignal.timeout(this.__timeout)
        })
    }

    /*getTokenForAdmin() {
        return fetch(this.__baseUrl + "/session/token.admin", {
            signal: AbortSignal.timeout(this.__timeout)
        })
    }*/
}

const sessionClient = new SessionClient("./api", 8000);

export default sessionClient;